import { Link } from 'react-router-dom';

interface ManhwaCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  status: string;
  category: string;
  tags: string[];
  chapters: number;
  size?: 'sm' | 'md' | 'lg';
}

export default function ManhwaCard({
  id,
  title,
  author,
  cover,
  rating,
  views,
  status,
  tags,
  chapters,
  size = 'md',
}: ManhwaCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  const coverSizes = {
    sm: 'h-48',
    md: 'h-64',
    lg: 'h-80',
  };

  const titleSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  return (
    <article className="group" data-product-shop="">
      <Link to={`/article/${id}`} className="block">
        <div className={`relative ${coverSizes[size]} rounded-lg overflow-hidden bg-background-200 mb-3`}>
          <img
            src={cover}
            alt={title}
            title={`${title} - 韩漫在线阅读`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
          <div className="absolute top-2 left-2">
            <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${
              status === '连载中'
                ? 'bg-accent-500 text-background-50'
                : 'bg-foreground-600 text-background-50'
            }`}>
              {status}
            </span>
          </div>
          <div className="absolute top-2 right-2 flex items-center gap-1 bg-background-950/70 backdrop-blur-sm rounded-full px-2 py-0.5">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
            </span>
            <span className="text-background-50 text-xs font-medium">{rating}</span>
          </div>
        </div>

        <h3 className={`${titleSizes[size]} font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1`}>
          {title}
        </h3>

        <p className="text-xs text-foreground-500 mb-2">{author}</p>

        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">
            <span className="w-3 h-3 inline-flex items-center justify-center mr-1">
              <i className="ri-eye-line text-xs"></i>
            </span>
            {formatViews(views)}
          </span>
          <span className="text-xs text-foreground-500">共{chapters}话</span>
        </div>

        {tags.length > 0 && size !== 'sm' && (
          <div className="flex flex-wrap gap-1 mt-2">
            {tags.slice(0, 3).map((tag) => (
              <span
                key={tag}
                className="inline-block px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </Link>
    </article>
  );
}